export const ROUTE_PATH = {
  LOGIN: '/',
  SUITE_LOUNGE_LOGIN: '/sl',
  TOP: '/top',
  /* リニューアル通知画面 */
  RENEWAL_NOTICE: '/renewal-notice',
  /* パスワード設定確認画面 */
  PASSWORD_SETTING_CONFIRM: '/password-setting-confirm',
  /* Bitkeyアカウント保有画面 */
  HAS_BITKEY_ACCOUNT: '/has-bitkey-account',
  SIGN_UP: '/sign-up',
  SIGN_UP_VERIFY: '/sign-up/verify',
  SIGN_UP_COMPLETE: '/sign-up/complete',
  SIGN_UP_CONFIRM: '/sign-up/confirm',
  NO_WORK_HUB_PASSWORD: '/sign-up/no-workhub-password',
  PASSWORD_RESET: '/password-reset',
  PASSWORD_RESET_SENT: '/password-reset/sent',
  CHANGE_PASSWORD: '/change-password',
  PASSWORD_RESET_COMPLETE: '/password-reset/complete',
  RESERVATION: '/reservation',
  RESERVATION_CONFIRM: '/reservation/confirmation',
  RESERVATION_COMPLETE: '/reservation/complete',
  RESERVATION_HISTORY: '/reservation/history',
  RESERVATION_DETAIL: '/reservation/history/:id',
  MY_PAGE: '/my-page',
  FAQ: '/faq',
  /* 共有端末：トップ画面 */
  SHARE_DEVICE: '/share-device',
  /* 共有端末：時間選択画面 */
  SHARE_DEVICE_TIME_SELECTION: '/share-device/time-selection',
  /* 共有端末：予約者情報入力画面 */
  SHARE_DEVICE_USER_INFO: '/share-device/user-info',
  /* 共有端末：予約結果詳細画面 */
  SHARE_DEVICE_COMPLETE: '/share-device/complete',
  /* 共有端末：ユーザー情報・ログアウト画面 */
  SHARE_DEVICE_ME: '/share-device/me',
  /* スタッフログイン画面 */
  STAFF_LOGIN: '/staff',
  /* スタッフ専用ページ */
  STAFF_ONLY: '/staff-only',
  /* スタッフ専用ページ：検索結果 */
  STAFF_ONLY_RESULTS: '/staff-only/results',
} as const;
